import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { createUseStyles } from 'features/sharedModules/styles/components/styles.js';
import * as R from 'ramda';

import { i18n } from 'i18n/index.js';
import { getAssetsNextRouteConfig } from 'features/shared/services/router/selectors.js';
import { usePrevRoute } from 'features/sharedModules/router/components/usePrevRoute.js';
import { useNextRoute } from 'features/sharedModules/router/components/useNextRoute.js';
import sessionSelectors from 'features/shared/services/session/selectors.js';
import userOptionsSelectors from 'features/shared/services/userOptions/selectors.js';
import { creators as userOptionsCreator } from 'features/shared/services/userOptions/actions.js';
import Button, { ButtonType } from 'features/shared/components/button/index';
import Navigation from 'features/shared/components/screenLayout/navigation';
import { TextFontSizes } from 'features/shared/constants/fonts.js';
import Slider from 'features/shared/components/slider/index.js';
import Layout from 'features/shared/components/screenLayout/layout.js';
import Page from 'features/shared/components/screenLayout/page.js';
import Footer from 'features/shared/components/screenLayout/footer.js';
import { Colors } from 'features/shared/constants/colors';

const useStyles = createUseStyles(theme => ({
  subTitle: {
    fontFamily: theme.subTitleFontFamily,
    fontSize: TextFontSizes.largePx,
    lineHeight: TextFontSizes.largeLineHeightPx,
    textAlign: 'center',
    paddingTop: '50px',
    paddingBottom: '20px',
    color: Colors.grayDark
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  }
}));

const Assets = () => {
  const classes = useStyles();
  const history = useHistory();
  const { customerId } = useParams();

  const prevRoute = usePrevRoute();
  const nextRoute = useNextRoute(getAssetsNextRouteConfig);

  const translations = useSelector(sessionSelectors.getTranslationsConfig);
  const financialSituationConfig = useSelector(
    sessionSelectors.getFinancialSituationConfig
  );
  const userFinancialSituation = useSelector(
    userOptionsSelectors.getUserFinancialSituation
  );

  const dispatch = useDispatch();
  const userFinancialSituationAssetsChanged = (type, value) => {
    dispatch(
      userOptionsCreator.userFinancialSituationAssetsChanged({
        type,
        value
      })
    );
  };

  return (
    <Layout>
      <Navigation prevRoute={prevRoute} customerId={customerId}>
        {i18n('financialSituation.assets.naviTitle', translations)}
      </Navigation>

      <Page>
        <div className={classes.content}>
          <span className={classes.subTitle}>
            {i18n('financialSituation.assets.subTitle', translations)}
          </span>
          {R.map(
            a => (
              <Slider
                key={a.id}
                options={a}
                userOption={R.prop(a.id, userFinancialSituation.assets)}
                onChange={(type, value) => {
                  userFinancialSituationAssetsChanged(a.id, value);
                }}
                displayTitle={true}
                displayValue={true}
              />
            ),
            financialSituationConfig.assets
          )}
        </div>

        <Footer>
          {nextRoute && (
            <Button
              disabled={R.pipe(
                R.map(a => R.prop(a.id, userFinancialSituation.assets)),
                R.any(R.isNil)
              )(financialSituationConfig.assets)}
              type={ButtonType.primary}
              onClick={() => {
                history.push(nextRoute.build(customerId));
              }}
            >
              {i18n('shared.continue', translations)}
            </Button>
          )}
        </Footer>
      </Page>
    </Layout>
  );
};

export default Assets;
